import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import http from "@/api";
import { useApp } from "@/context";
import ProductCard from "@/components/ProductCard";

export default function Offers() {
  const { lang } = useApp();
  const ar = lang === "ar";
  const [items, setItems] = useState(null);

  useEffect(() => {
    http.get("/products/offers?limit=40")
      .then(({ data }) => setItems(Array.isArray(data) ? data : []))
      .catch(() => setItems([]));
  }, []);

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 py-4 space-y-4" data-testid="offers-page">
      <div className="text-center space-y-1">
        <h1 className="text-2xl font-black">{ar ? "🔥 العروض" : "🔥 Offers"}</h1>
        <p className="text-xs opacity-60">
          {ar ? "خصومات حقيقية على باقات وهدايا مختارة — الأقوى خصماً أولاً" : "Real discounts on selected gifts — biggest first"}
        </p>
      </div>
      {items === null ? (
        <div className="py-14 flex justify-center"><Loader2 className="animate-spin text-emerald-700" size={26} /></div>
      ) : items.length === 0 ? (
        <div className="py-14 text-center space-y-3" data-testid="offers-empty">
          <div className="text-4xl">🌸</div>
          <div className="text-sm opacity-60">{ar ? "لا توجد عروض حالياً — عد قريباً!" : "No offers right now — check back soon!"}</div>
          <Link to="/shop" className="btn-primary !py-2.5 !px-6 text-sm inline-flex" data-testid="offers-shop-btn">
            {ar ? "تسوّق المتجر" : "Browse shop"}
          </Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3" data-testid="offers-grid">
          {items.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
      )}
    </div>
  );
}
